import { render, staticRenderFns } from "./Chauffeurs.vue?vue&type=template&id=6cbfff60&"
import script from "./Chauffeurs.vue?vue&type=script&lang=js&"
export * from "./Chauffeurs.vue?vue&type=script&lang=js&"
import style0 from "./Chauffeurs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports